export default __webpack_public_path__ + "static/media/evangelus-grey.13eead24.svg";